export default __webpack_public_path__ + "static/media/Maria_Dimou.245fc079.png";